import { put } from 'redux-saga/effects'
import { push } from 'connected-react-router';
import Dashboard from "../services/dashboard";
// import AppApi from "../services/appApi";
import {
    GET_DIT_PMS_DASHBOARD, GET_DIT_PMS_DASHBOARD_SUCCESS, GET_DIT_PMS_DASHBOARD_FAILURE
} from '../redux/types/dashboard';
import {
    GET_COMMISSION_TREND_YEAR_TRADE_DAY, GET_COMMISSION_TREND_YEAR_TRADE_DAY_SUCCESS, GET_COMMISSION_TREND_YEAR_TRADE_DAY_FAILURE
} from '../redux/types/getcommissiontrendYTD';
import {
    GET_PMS_DIT_ACTIVE_YEAR, GET_PMS_DIT_ACTIVE_YEAR_SUCCESS, GET_PMS_DIT_ACTIVE_YEAR_FAILURE
} from '../redux/types/getpmsditActiveYear';
import {
    GET_PMS_DIT_SALES_OVERVIEW_MTD, GET_PMS_DIT_SALES_OVERVIEW_MTD_SUCCESS, GET_PMS_DIT_SALES_OVERVIEW_MTD_FAILURE
} from '../redux/types/getpmsditSalesOverViewMTD';
import {
    GET_PMS_DIT_AUM_TREND_YTD, GET_PMS_DIT_AUM_TREND_YTD_SUCCESS, GET_PMS_DIT_AUM_TREND_YTD_FAILURE
} from '../redux/types/getpmsditAUMTrendYTD';
import {
    GET_PMS_DIT_INVENTOR_TREND_YTD, GET_PMS_DIT_INVENTOR_TREND_YTD_SUCCESS, GET_PMS_DIT_INVENTOR_TREND_YTD_FAILURE
} from '../redux/types/getpmsditInvestorTrendYTD';
import { GET_PMS_DIT_SALES_OVERVIEW_YTD_SUCCESS, GET_PMS_DIT_SALES_OVERVIEW_YTD_FAILURE } from '../redux/types/getpmsditSalesOverYTD';
let api = new Dashboard();
// let api2 = new AppApi()


// export function* GETPMSDITDashboard({ payload, resolve }) {
//     let responsePayload = {};
//     try {
//         let { data } = yield api.GETPMSDITDashboard(payload);
//         if (data.success) {
//             let responseData = data.data;
//             responsePayload = responseData;
//             yield put({ type: GET_DIT_PMS_DASHBOARD, payload: responsePayload })
//             resolve && resolve(responsePayload)
//         }
//         else {
//             if (data.success === undefined) {
//                 // yield put(push('/'))
//             }
//             resolve && resolve(data)
//             yield put({ type: GET_DIT_PMS_DASHBOARD_FAILURE, payload: responsePayload })
//         }
//     } catch (e) {
//         // yield put(push('/'))
//         yield put({ type: GET_DIT_PMS_DASHBOARD_FAILURE, payload: responsePayload })
//         resolve && resolve(responsePayload)
//     }
// }
export function* GETPMSDITDashboard({ payload, resolve }) {
    console.log("start details")
    let responsePayload = {};
    try {
        let { data, code } = yield api.GETPMSDITDashboard(payload);
        if (data.success) {
            let responseData = data.data;
            console.log("responseDatahdhdhdhdh", responseData);
            responsePayload.GETPMSDITDashboard = responseData;
            yield put({ type: GET_DIT_PMS_DASHBOARD_SUCCESS, payload: responsePayload })
            resolve && resolve(data.data)
        } else {
            resolve && resolve(data)
            yield put({ type: GET_DIT_PMS_DASHBOARD_FAILURE, payload: data })
        }
    } catch (e) {
        yield put({ type: GET_DIT_PMS_DASHBOARD_FAILURE, payload: responsePayload })

    }
}

export function* GETPMSDITActiveYear({ payload, resolve }) {
    console.log("start details")
    let responsePayload = {};
    try {
        let { data, code } = yield api.GETPMSDITActiveYear(payload);
        if (data.success) {
            let responseData = data.data;
            console.log("response from GET_PMS_DIT_ACTIVE_YEAR", responseData);
            responsePayload.GETPMSDITActiveYear = responseData;
            yield put({ type: GET_PMS_DIT_ACTIVE_YEAR_SUCCESS, payload: responsePayload })
            resolve && resolve(data.data)
        } else {
            resolve && resolve(data)
            yield put({ type: GET_PMS_DIT_ACTIVE_YEAR_FAILURE, payload: data })
        }
    } catch (e) {
        yield put({ type: GET_PMS_DIT_ACTIVE_YEAR_FAILURE, payload: responsePayload })

    }
}


export function* GETPMSDITCommissionTrendYTD({ payload, resolve }) {
    console.log("start details")
    let responsePayload = {};
    try {
        let { data, code } = yield api.GETPMSDITCommissionTrendYTD(payload);
        if (data.success) {
            let responseData = data.data;
            console.log("responseddddddddhdh", responseData);
            responsePayload.GETPMSDITCommissionTrendYTD = responseData;
            yield put({ type: GET_COMMISSION_TREND_YEAR_TRADE_DAY_SUCCESS, payload: responsePayload })
            resolve && resolve(data.data)
        } else {
            resolve && resolve(data)
            yield put({ type: GET_COMMISSION_TREND_YEAR_TRADE_DAY_FAILURE, payload: data })
        }
    } catch (e) {
        yield put({ type: GET_COMMISSION_TREND_YEAR_TRADE_DAY_FAILURE, payload: responsePayload })

    }
}

export function* GETPMSDITSalesOverViewMTD({ payload, resolve }) {
    console.log("start details")
    let responsePayload = {};
    try {
        let { data, code } = yield api.GETPMSDITSalesOverViewMTD(payload);
        if (data.success) {
            let responseData = data.data;
            console.log("responseddddddddhdh", responseData);
            responsePayload.GETPMSDITSalesOverViewMTD = responseData;
            yield put({ type: GET_PMS_DIT_SALES_OVERVIEW_MTD_SUCCESS, payload: responsePayload })
            resolve && resolve(data.data)
        } else {
            resolve && resolve(data)
            yield put({ type: GET_PMS_DIT_SALES_OVERVIEW_MTD_FAILURE, payload: data })
        }
    } catch (e) {
        yield put({ type: GET_PMS_DIT_SALES_OVERVIEW_MTD_FAILURE, payload: responsePayload })

    }
}
export function* GETPMSDITAUMTrendYTD({ payload, resolve }) {
    console.log("start details")
    let responsePayload = {};
    try {
        let { data, code } = yield api.GETPMSDITAUMTrendYTD(payload);
        if (data.success) {
            let responseData = data.data;
            console.log("responseddddddddhdh", responseData);
            responsePayload.GETPMSDITAUMTrendYTD = responseData;
            yield put({ type: GET_PMS_DIT_AUM_TREND_YTD_SUCCESS, payload: responsePayload })
            resolve && resolve(data.data)
        } else {
            resolve && resolve(data)
            yield put({ type: GET_PMS_DIT_AUM_TREND_YTD_FAILURE, payload: data })
        }
    } catch (e) {
        yield put({ type: GET_PMS_DIT_AUM_TREND_YTD_FAILURE, payload: responsePayload })

    }
}
export function* GETPMSDITInvestorTrendYTD({ payload, resolve }) {
    console.log("start details")
    let responsePayload = {};
    try {
        let { data, code } = yield api.GETPMSDITInvestorTrendYTD(payload);
        if (data.success) {
            let responseData = data.data;
            console.log("responseddddddddhdh", responseData);
            responsePayload.GETPMSDITInvestorTrendYTD = responseData;
            yield put({ type: GET_PMS_DIT_INVENTOR_TREND_YTD_SUCCESS, payload: responsePayload })
            resolve && resolve(data.data)
        } else {
            resolve && resolve(data)
            yield put({ type: GET_PMS_DIT_INVENTOR_TREND_YTD_FAILURE, payload: data })
        }
    } catch (e) {
        yield put({ type: GET_PMS_DIT_INVENTOR_TREND_YTD_FAILURE, payload: responsePayload })

    }
}
export function* GETPMSDITSalesOverViewYTD({ payload, resolve }) {
    console.log("start details")
    let responsePayload = {};
    try {
        let { data, code } = yield api.GETPMSDITSalesOverViewYTD(payload);
        if (data.success) {
            let responseData = data.data;
            console.log("responseddddddddhdh", responseData);
            responsePayload.GETPMSDITSalesOverViewYTD = responseData;
            yield put({ type: GET_PMS_DIT_SALES_OVERVIEW_YTD_SUCCESS, payload: responsePayload })
            resolve && resolve(data.data)
        } else {
            resolve && resolve(data)
            yield put({ type: GET_PMS_DIT_SALES_OVERVIEW_YTD_FAILURE, payload: data })
        }
    } catch (e) {
        yield put({ type: GET_PMS_DIT_SALES_OVERVIEW_YTD_FAILURE, payload: responsePayload })

    }
}
